module.exports = __webpack_public_path__ + "files/0b1c404559bec83ae916e338d5047681.png";